export default __webpack_public_path__ + "static/lframe-inspiration-7ca0a54603dff7c8fe9b69487d6c9386.png";